/******************************************************************************************
 * Reseller Plan Types Constant
 *******************************************************************************************
 *
 * PLAN_TYPE are generic constants for the two different plan types.
 * REQUESTED_PLAN_TYPES is list of plan types selectable as "Plan Type" in Add Customer modal.
 * RESELLER_PLAN_TYPES is used by the icon directive to display the customer's type icons.
 *
 */
(function() {


  angular
    .module('rcServices.resellerPlanTypes', [])
    .constant('PLAN_TYPE', {
      TEAM: 'TEAM',
      ENTERPRISE: 'EVIP'
    })
    .constant('REQUESTED_PLAN_TYPES', [
      {
        label: 'planType.enterprise',
        value: 'EVIP' // value = PLAN_TYPE.ENTERPRISE
      },
      {
        label: 'planType.team',
        value: 'TEAM' // value = PLAN_TYPE.TEAM
      }
    ])
    .constant('RESELLER_PLAN_TYPES', {
      TEAM: {
        label: 'planType.team',
        iconClass: 'image-icon-team-type'
      },
      EVIP: {
        label: 'planType.enterprise',
        iconClass: 'image-icon-enterprise-type'
      },
      NOPLAN: {
        label: 'planType.noPlan'
      }
    })
    .service(
      'ResellerPlanTypes',
      /* @ngInject */
      function(RESELLER_PLAN_TYPES, PLAN_TYPE, $translate, translationUtils) {
        this.getPlanType = function(planTypeCode) {
          if (planTypeCode && RESELLER_PLAN_TYPES[planTypeCode]) {
            return RESELLER_PLAN_TYPES[planTypeCode];
          } else {
            return null;
          }
        };

        // planTypesArr is an array which may be empty if there is no planType.
        // Returns a comma separated string.
        this.getResellerPlanTypeString = function(planTypesArr) {
          var label;

          if (planTypesArr && planTypesArr.length) {
            this.sortPlanTypes(planTypesArr);

            label = '';
            for (var i = 0; i < planTypesArr.length; i++) {
              if (label) {
                label += ', ';
              }

              var planTypeCode = planTypesArr[i];
              label += translationUtils.sanitizeSafeInstant(this.getPlanType(planTypeCode).label);
            }
          } else {
            label = translationUtils.sanitizeSafeInstant(RESELLER_PLAN_TYPES.NOPLAN.label);
          }

          return label;
        };

        // planTypesArr is an array which may be empty or undefined if there is no planType.
        // Returns 'Team, 'Enterprise', 'Team/Enterprise' or ''.
        this.getResellerPlanTypeLabel = function(planTypesArr) {
          var label = '';

          if (planTypesArr && planTypesArr.length) {
            this.sortPlanTypes(planTypesArr);

            if (planTypesArr.length === 1) {
              var planTypeCode = planTypesArr[0];
              label = translationUtils.sanitizeSafeInstant(this.getPlanType(planTypeCode).label);
            } else {
              label = $translate.instant('planType.teamAndEnterprise');
            }
          }

          return label;
        };

        // Sort the planTypesArr array so 'TEAM' is first, and 'EVIP' is 2nd.
        this.sortPlanTypes = function(planTypesArr) {
          if (planTypesArr) {
            planTypesArr.sort(function(a, b) {
              if (a === b) {
                return 0;
              }
              if (a === PLAN_TYPE.TEAM) {
                return -1;
              }
              if (a === PLAN_TYPE.ENTERPRISE) {
                return 1;
              }

              // Shouldn't get here.
              return 0;
            });
          }

          return planTypesArr;
        };
      }
    );
})();
